import { spacing, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const twoColumn = objectWithClassName({
  display: "grid",
  gridTemplateColumns: "1fr",
  gridGap: spacing.md,
  className: [
    `umd-layout-grid-masonry`,
    /** @deprecated Use 'umd-layout-grid-masonry' instead */
    "umd-grid-gap-masonry"
  ],
  [`@media (${media.queries.tablet.min})`]: {
    gridTemplateColumns: "1fr 1fr",
    gridGap: spacing.lg
  },
  [`@media (${media.queries.desktop.min})`]: {
    gridGap: spacing.xl
  },
  "& > *": {
    "& > *": {
      width: "100%",
      height: "100%"
    }
  },
  "& > *:nth-of-type(odd)": {
    [`@media (${media.queries.tablet.min})`]: {
      marginTop: `-${spacing.lg}`,
      marginBottom: `${spacing.lg}`
    },
    [`@media (${media.queries.desktop.min})`]: {
      marginTop: `-${spacing.xl}`,
      marginBottom: `${spacing.xl}`
    }
  },
  "& > *:nth-of-type(even)": {
    [`@media (${media.queries.tablet.min})`]: {
      marginTop: "0"
    }
  },
  "& > *:first-child": {
    [`@media (${media.queries.tablet.min})`]: {
      marginTop: "0"
    }
  },
  "& > *:nth-of-type(2)": {
    [`@media (${media.queries.tablet.min})`]: {
      marginTop: `${spacing.lg}`
    },
    [`@media (${media.queries.desktop.min})`]: {
      marginTop: `${spacing.xl}`
    }
  }
});
export {
  twoColumn
};
//# sourceMappingURL=masonary.js.map
